import AdminNavBar from '@/components/AdminNavBar/AdminNavBar.vue';
import { API_BASE_URL } from "@/config";
import { validateToken } from '@/utils/auth';
import { useToast } from "@/components/Toast/useToast";
import Swal from 'sweetalert2';
import $ from 'jquery';

export default {
  name: 'WorkflowNotifications',
  components: {
    AdminNavBar,
  },
  setup() {
    const { showSuccess, showError, showWarning } = useToast();
    
    return {
      showSuccess,
      showError,
      showWarning
    };
  },
  data: () => ({
    enteredEmail: '',
    selectedEmailOption: '',
    selectedEmail: '',
    emailOptions: [],
    filteredEmailOptions: [],
    searchQuery: '',
    showDropdown: false,
    isLoadingUsers: false,
    isLoadingNotifications: false,
    workflowId: null,
    notificationUsers: [],
    workflowNotifications: [],
    emailError: ''
  }),
  methods: {
    workflow_notifications(workflow_id) {
      this.$router.push({ name: 'workflow_notifications', params: { workflow_id } });
    },

    fetch_users() {
      this.isLoadingUsers = true;
      const TOKEN = localStorage.getItem('token');

      $.ajax({
        url: `${API_BASE_URL}/verify_api/workflow_management_api/get_users_api/`,
        method: 'GET',
        dataType: 'json',
        headers: { Authorization: `Token ${TOKEN}`, 'Content-Type': 'application/json' },
        success: (response) => {
          if (response.status === 'success') {
            this.emailOptions = response.data.map((user, index) => ({
              id: index + 1,
              name: user.name,
              address: user.address
            }))
            // Sort emails in ascending order
            .sort((a, b) => a.address.toLowerCase().localeCompare(b.address.toLowerCase()));
            
            this.filteredEmailOptions = [...this.emailOptions];
          } else {
            this.showError(response.message || 'Failed to load users.');
          }
        },
        error: () => {
          this.showError('Error loading users.');
        },
        complete: () => {
          this.isLoadingUsers = false;
        }
      });
    },

    fetch_workflow_notifications() {
      this.isLoadingNotifications = true;
      const TOKEN = localStorage.getItem('token');

      $.ajax({
        url: `${API_BASE_URL}/verify_api/workflow_management_api/get_workflow_notifications_api/${this.workflowId}/`,
        method: 'GET',
        dataType: 'json',
        headers: { Authorization: `Token ${TOKEN}`, 'Content-Type': 'application/json' },
        success: (response) => {
          if (response.status === 'success') {
            this.workflowNotifications = response.data;
            this.notificationUsers = response.data.map((notification, index) => ({
              id: notification.id,
              display_id: index + 1,
              first_name: notification.email,
              last_name: '',
              email: notification.email,
              date_created: notification.date_created || new Date().toISOString().split('T')[0]
            }));
          } else {
            this.notificationUsers = [];
            this.showError(response.message || 'Failed to fetch workflow notifications.');
          }
        },
        error: () => {
          this.notificationUsers = [];
          this.showError('Error fetching workflow notifications.');
        },
        complete: () => {
          this.isLoadingNotifications = false;
        }
      });
    },

    handle_email_option_change() {
      this.selectedEmail = '';
      this.searchQuery = '';
      this.showDropdown = false;
      this.emailError = '';
      this.filteredEmailOptions = [...this.emailOptions];
      if (this.selectedEmailOption === 'select' && this.emailOptions.length === 0) {
        this.fetch_users();
      }
    },

    onSearchFocus() {
      this.showDropdown = true;
      this.filteredEmailOptions = [...this.emailOptions];
      if (this.emailOptions.length === 0 && !this.isLoadingUsers) {
        this.fetch_users();
      }
    },

    onSearchBlur() {
      this.showDropdown=false;
    },

    filterEmails() {
      this.showDropdown = true;
      if (!this.searchQuery) {
        this.filteredEmailOptions = [...this.emailOptions];
      } else {
        this.filteredEmailOptions = this.emailOptions.filter(email => 
          email.address.toLowerCase().includes(this.searchQuery.toLowerCase()) ||
          email.name.toLowerCase().includes(this.searchQuery.toLowerCase())
        );
      }
    },

    selectEmail(email) {
      this.selectedEmail = email.address;
      this.searchQuery = `${email.name} - ${email.address}`;
      this.showDropdown = false;
      this.handle_email_selection();
    },

    handle_email_selection() {
      if (this.selectedEmail) {
        const selectedEmailObj = this.emailOptions.find(email => email.address === this.selectedEmail);
        const emailExists = this.notificationUsers.some(user => user.email === this.selectedEmail);

        if (emailExists) {
          this.showWarning('This email is already in the list!');
          this.selectedEmail = '';
          this.searchQuery = '';
          return;
        }

        if (selectedEmailObj) {
          this.save_notification_to_API(this.selectedEmail, () => {
            this.fetch_workflow_notifications();
            this.showSuccess(`Email ${this.selectedEmail} added successfully!`);
            this.selectedEmail = '';
            this.searchQuery = '';
            this.filteredEmailOptions = [...this.emailOptions];
          });
        }
      }
    },

    save_email() {
      // Clear previous error
      this.emailError = '';

      // Check if email field is empty
      if (!this.enteredEmail || this.enteredEmail.trim() === '') {
        this.emailError = 'Please fill out this field';
        return;
      }

      // Check if email is valid
      if (!this.isValidEmail(this.enteredEmail)) {
        this.emailError = 'Please enter a valid email address';
        return;
      }

      // Check if email already exists
      const emailExists = this.notificationUsers.some(user => user.email === this.enteredEmail);
      if (emailExists) {
        this.emailError = 'This email is already in the list!';
        return;
      }

      // Save the email
      this.save_notification_to_API(this.enteredEmail, () => {
        this.fetch_workflow_notifications();
        this.showSuccess('Email added successfully!');
        this.cancel_email();
      });
    },

    cancel_email() {
      this.enteredEmail = '';
      this.selectedEmailOption = '';
      this.searchQuery = '';
      this.selectedEmail = '';
      this.showDropdown = false;
      this.emailError = '';
    },
    
    clearEmailError() {
    if (this.emailError) {
      this.emailError = '';
    }
   },
    async remove_notification(userId) {
      const userIndex = this.notificationUsers.findIndex(user => user.id === userId);
      if (userIndex === -1) {
        this.showError('Email not found!');
        return;
      }

      const user = this.notificationUsers[userIndex];

      const result = await Swal.fire({
        title: 'Are you sure?',
        text: `You want to remove the email "${user.email}" from workflow notifications?`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes, remove it!',
        cancelButtonText: 'Cancel',
        reverseButtons: true
      });

      if (!result.isConfirmed) return;

      this.remove_notification_from_API(user.id, () => {
        this.notificationUsers.splice(userIndex, 1);
        this.notificationUsers.forEach((u, index) => { u.display_id = index + 1; });
        this.showSuccess(`Email ${user.email} removed successfully!`);
      });
    },

    remove_notification_from_API(notificationId, onSuccess) {
      const TOKEN = localStorage.getItem('token');

      $.ajax({
        url: `${API_BASE_URL}/verify_api/workflow_management_api/delete_workflow_notification_api/${notificationId}/`,
        method: 'DELETE',
        dataType: 'json',
        headers: { Authorization: `Token ${TOKEN}`, 'Content-Type': 'application/json' },
        success: (response) => {
          if (response.status === 'success') {
            onSuccess();
          } else {
            this.showError(response.message || 'Failed to remove notification');
          }
        },
        error: (error) => {
          const message = error?.responseJSON?.message || 'Failed to remove notification';
          this.showError(message);
        }
      });
    },

    save_notification_to_API(email, onSuccess) {
      const TOKEN = localStorage.getItem('token');
      const workflow_id = this.$route.params.workflow_id;

      if (!workflow_id) {
        this.showError('Workflow ID is required.');
        return;
      }

      $.ajax({
        url: `${API_BASE_URL}/verify_api/workflow_management_api/save_workflow_notification_api/`,
        method: 'POST',
        dataType: 'json',
        headers: { Authorization: `Token ${TOKEN}`, 'Content-Type': 'application/json' },
        data: JSON.stringify({ workflow_id, email }),
        success: (response) => {
          if (response.status === 'success') {
            onSuccess();
          } else {
            this.showError(response.message || 'Failed to save notification.');
          }
        },
        error: (error) => {
          const message = error?.responseJSON?.message || 'Failed to save email notification.';
          this.showError(message);
        }
      });
    },

    isValidEmail(email) {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      return emailRegex.test(email);
    },
  },

  mounted() {
    if (!validateToken(this.$router)) return;
    this.workflowId = this.$route.params.workflow_id;
    this.fetch_workflow_notifications();
  }
};